<template>
  <div class="row match-height" v-if="isLoaded">
    <div class="col-xl-12 col-lg-12">
      <ul class="nav nav-tabs nav-topline nav-justified" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            href="#tabs-1-tab-1"
            role="tab"
            data-toggle="tab"
            aria-expanded="true"
          >
            <span class="nav-link-in">
              <i class="font-icon font-icon-cogwheel"></i>
              Conta
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#tabs-1-tab-2"
            role="tab"
            data-toggle="tab"
            aria-expanded="true"
            @click="getDataCte()"
          >
            <span class="nav-link-in">
              <i class="font-icon font-icon-cogwheel"></i>
              CTE
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#tabs-1-tab-3"
            role="tab"
            data-toggle="tab"
            aria-expanded="false"
            @click="getDataIntegracao()"
          >
            <span class="nav-link-in">
              <i class="fa fa-list"></i>
              Integração
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#tabs-1-tab-4"
            role="tab"
            data-toggle="tab"
            aria-expanded="false"
            @click="getDataSeguranca()"
          >
            <span class="nav-link-in">
              <i class="fa fa-shield"></i>
              Segurança
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content card">
        <div
          role="tabpanel"
          class="tab-pane active show"
          id="tabs-1-tab-1"
          aria-expanded="true"
        >
          <ContaForm />
        </div>

        <div
          role="tabpanel"
          class="tab-pane fade"
          id="tabs-1-tab-2"
          aria-expanded="false"
        >
          <CteForm ref="cteform" />
        </div>

        <div
          class="tab-pane fade"
          id="tabs-1-tab-3"
          role="tabpanel"
          aria-expanded="true"
        >
          <IntrgracaoForm ref="integracaoform" />
        </div>
        <div
          role="tabpanel"
          class="tab-pane fade"
          id="tabs-1-tab-4"
          aria-expanded="true"
        >
          <SegurancaForm ref="segurancaform" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueClipboard from "vue-clipboard2";
import ToggleButton from "vue-js-toggle-button";
import moment from "moment";
import ContaForm from "./ContaContaForm.vue";
import CteForm from "./CteContaForm.vue";
import IntrgracaoForm from "./IntegracaoContaForm.vue";
import SegurancaForm from "./SegurancaContaForm.vue";

Vue.use(VueClipboard);
Vue.use(ToggleButton);

export default {
  components: {
    ContaForm,
    CteForm,
    IntrgracaoForm,
    SegurancaForm,
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      teste: "",
      isFullscreen: false,
      loading: false,
      disabled: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalPermission: false,
      optionsTpRegraSenha: [],
      optionsCorSistema: [],
      optionsLinkSuporte: [],
      optionsLivTpIntegracaoFatura: [],
      optionsLivTpIntegracaoCte: [],
      optionsLivTpIntegracaoSefaz: [],
      optionsLivTpAuthCode: [],
      optionsLivManterLogado: [],
      optionsLivStatusDicionario: [],
      optionsLivStatusDoisFatores: [],
      optionsLivTpIntegracaoCliente: [],
      optionsPrmGeralRetira: [],
      optionsLivTpDoisFatoresAlternativo: [],
      optionsLivTpDoisFatoresPrimario: [],
      optionsParamTpEmail: [],
      optionsEncerraAutomaticoVlrCteMenor: [],
      optionsTransferenciaInterna: [],
      optionsBPlano: [],
      optionsParamTpEmailCte: [],
      optionsLivApiExternaTpAuth: [],
      optionsCustos: [],
      optionsPessoaFisica: [],
      optionsEncerraMdfeAutomatico: [],
      optionsTpVlrDespacho: [],
      optionsValidaRegraAdiantamento: [],
      optionsValidaTransfCalcIndiv: [],
      optionsPessoaJuridica: [],
      optionsGeraNumCliente: [],
      moreParams: {},
      helpForm: new Form({
        statusRecord: [],
        senhadicionario: [],
        params: [],
        search: "",
      }),
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.$events.$on("reloadResponse", (response) =>
      this.onReloadResponse(response)
    );
    // console.log("ue");
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function(data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    getDataCte() {
      this.$refs.cteform.cteData();
    },
    getDataIntegracao() {
      this.$refs.integracaoform.integracaoData();
    },
    getDataSeguranca() {
      this.$refs.segurancaform.segurancaData();
    },

    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },

    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    onReloadResponse(response) {
      new ReturnApi(response, this);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    getLivGeral() {
      this.helpForm
        .get("/api/conta/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.custos.forEach((obj) => {
            this.optionsCustos.push({
              label: obj.descr,
              value: obj.custo_id,
            });
          });
          response.b_plano.forEach((obj) => {
            this.optionsBPlano.push({
              label:
                obj.descr +
                " | Qtde. CTe: " +
                obj.qtde_cte +
                "| Qtde. MDFe: " +
                obj.qtde_mdfe +
                "| Qtde. Unidade: " +
                obj.qtde_unidade,
              value: obj.bplano_id,
            });
          });
          response.param_tp_email.forEach((obj) => {
            this.optionsParamTpEmail.push({
              label: obj.descr,
              value: obj.partpema_id,
            });
            this.optionsParamTpEmailCte.push({
              label: obj.descr,
              value: obj.partpema_id,
            });
          });

          response.tp_integracao_cte.forEach((obj) => {
            this.optionsLivTpIntegracaoCte.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_regra_senha.forEach((obj) => {
            this.optionsTpRegraSenha.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.cor_sistema.forEach((obj) => {
            this.optionsCorSistema.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.gera_num_cliente.forEach((obj) => {
            this.optionsGeraNumCliente.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.encerra_mdfe_automatico.forEach((obj) => {
            this.optionsEncerraMdfeAutomatico.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.valida_regra_adiantamento.forEach((obj) => {
            this.optionsValidaRegraAdiantamento.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.doc_transf_calc_indiv.forEach((obj) => {
            this.optionsValidaTransfCalcIndiv.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.link_suporte.forEach((obj) => {
            this.optionsLinkSuporte.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_integracao_sefaz.forEach((obj) => {
            this.optionsLivTpIntegracaoSefaz.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_integracao_fatura.forEach((obj) => {
            this.optionsLivTpIntegracaoFatura.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_integracao_cliente.forEach((obj) => {
            this.optionsLivTpIntegracaoCliente.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_auth_code.forEach((obj) => {
            this.optionsLivTpAuthCode.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.manter_logado.forEach((obj) => {
            this.optionsLivManterLogado.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.status_dicionario.forEach((obj) => {
            this.optionsLivStatusDicionario.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.status_dois_fatores.forEach((obj) => {
            this.optionsLivStatusDoisFatores.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.dois_fatores_alternativo.forEach((obj) => {
            this.optionsLivTpDoisFatoresAlternativo.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.dois_fatores_primario.forEach((obj) => {
            this.optionsLivTpDoisFatoresPrimario.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.api_externa_tp_auth.forEach((obj) => {
            this.optionsLivApiExternaTpAuth.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.encerra_automatico_vlr_cte_menor.forEach((obj) => {
            this.optionsEncerraAutomaticoVlrCteMenor.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.transferencia_interna.forEach((obj) => {
            this.optionsTransferenciaInterna.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.prm_geral_retira.forEach((obj) => {
            this.optionsPrmGeralRetira.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_vlr_despacho.forEach((obj) => {
            this.optionsTpVlrDespacho.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
